import { HttpInterceptorFn } from '@angular/common/http';
import { CORRELATION_HEADER, createCorrelationId } from '../utils/correlation-id';

export const correlationIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has(CORRELATION_HEADER)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        [CORRELATION_HEADER]: createCorrelationId(),
      },
    }),
  );
};
